import { Card } from "@/components/ui/card";
import { gainClass } from "@/lib/format";

function Cell({ label, value, delta, deltaPct, sub, valueClass = "", testId, onClick, dayOn }) {
    return (
        <div className={`px-3 py-2.5 min-w-0 h-full ${onClick ? "cursor-pointer hover:bg-muted/40 transition-colors" : ""}`} data-testid={testId}
            onClick={onClick} role={onClick ? "button" : undefined} tabIndex={onClick ? 0 : undefined}>
            <div className="text-[10px] uppercase tracking-wider font-semibold text-muted-foreground truncate">{label}</div>
            <div className="mt-0.5 flex items-baseline gap-1.5 flex-wrap">
                <span className={`num font-semibold text-base leading-tight ${valueClass}`} data-testid={`${testId}-value`}>{value}</span>
                {deltaPct && deltaPct !== "—" && <span className={`num text-xs font-medium ${dayOn === false ? "text-foreground" : gainClass(delta)}`} data-testid={`${testId}-delta`}>{deltaPct}</span>}
            </div>
            {sub && <div className="text-[11px] text-muted-foreground truncate">{sub}</div>}
        </div>
    );
}

/** One condensed card holding the headline portfolio figures. */
export function PortfolioStrip({ cells, cols = 5 }) {
    const lg = { 3: "lg:grid-cols-3", 4: "lg:grid-cols-4", 6: "lg:grid-cols-6" }[cols] || "lg:grid-cols-5";
    const sm = cols === 4 ? "sm:grid-cols-4" : "sm:grid-cols-3";
    return (
        <Card className="overflow-hidden" data-testid="portfolio-strip">
            {/* each cell draws its right/bottom rule; the -1px margins tuck the outer ones under the card edge */}
            <div className={`grid grid-cols-2 ${sm} ${lg} -mr-px -mb-px`}>
                {cells.map((c, i) => (
                    // odd count on 2-column phones: let the last cell span the row instead of leaving a gap
                    <div key={c.testId} className={`border-r border-b border-border ${i === cells.length - 1 && cells.length % 2 ? "col-span-2 sm:col-span-1" : ""}`}><Cell {...c} /></div>
                ))}
            </div>
        </Card>
    );
}
